<intervenn-sample-receive (onSampleReceived)="loadPackagesLazy(null)"></intervenn-sample-receive>
<div class="mt-4">
  <p-table #requisitionlist [columns]="cols" [value]="requisitions" [lazy]="true" (onLazyLoad)="loadPackagesLazy($event)" [paginator]="true"
           [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
    <ng-template pTemplate="caption" [style]="{'height':'30px !important', 'background-color': 'rgb(123, 149, 163) !important'}">
      <div style="height: 30px; width: 100%; background-color: rgb(123, 149, 163)">
        <span class="float-left">Requisition List</span>
        <div class="float-right">
          <input pInputText type="text" (keypress)="handleSearchKey($event, requisitionlist)" placeholder="Search" [style]="{'margin-right':'15px'}" [ngModel]="searchTerm" />
          <a (click)="loadPackagesLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width:50px">&nbsp;</th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
        </th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td>
          <a style="cursor:pointer" (click)="rowData['showDetail'] = !rowData['showDetail'];"><i class="fa fa-eye"></i></a>
        </td>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <span *ngSwitchDefault>{{rowData[col.field]}}</span>
          <span *ngSwitchCase="'BirthDate'">
            {{rowData[col.field] | date:'MM/dd/yyyy'}}
          </span>
          <span *ngSwitchCase="'DateOfService'">
            {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
          </span>
          <span *ngSwitchCase="'DateReceived'">
            {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
          </span>
          <span *ngSwitchCase="'StatusDate'">
            {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
          </span>

        </td>
      </tr>
      <tr *ngIf="rowData['showDetail'] == true">
        <td colspan="11" style="background-color: lightgray; padding: 15px">
          <app-receiving-sample requisitionId="{{rowData['Id']}}" (onSampleUpdated)="sampleDisplayed(rowData['Id'])" packageDeliveredDate="{{rowData['DateReceived']}}"></app-receiving-sample>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-toast>
</p-toast>
